export const MEMBER_INVOICE_TABLE = 'member-invoice-table'
export const MEMBER_BALANCE_HISTORY_TABLE = 'member-balance-history-table'
